/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Webauthn_Not_SupportedInputs */



/**
* | output |
* | --- |
* | "Passkey authentication is not supported on this device or browser." |
*
* @param {Auth_Webauthn_Not_SupportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_webauthn_not_supported = /** @type {((inputs?: Auth_Webauthn_Not_SupportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Webauthn_Not_SupportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passkeys werden von diesem Browser nicht unterstützt. Bitte verwende einen kompatiblen Browser.")
	return /** @type {LocalizedString} */ ("Passkey authentication is not supported on this device or browser.")
});